import { render, staticRenderFns } from "./UsersBody.vue?vue&type=template&id=686dc2e1&scoped=true&"
import script from "./UsersBody.vue?vue&type=script&lang=ts&"
export * from "./UsersBody.vue?vue&type=script&lang=ts&"
import style0 from "./UsersBody.vue?vue&type=style&index=0&id=686dc2e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686dc2e1",
  null
  
)

export default component.exports